import { Breakpoint, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export const useMobileSize = (breakpointValue: number | Breakpoint = 'md') => {
  const theme = useTheme()
  const mobileSize = useMediaQuery(theme.breakpoints.down(breakpointValue))

  return mobileSize
}
